import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/policy',
    name: 'Policy',
    component: () => import('../views/recorder/policy'),
    meta: {
      titile: '隐私政策'
    }
  },
  {
    path: '/LKdownLoad',
    name: 'LKdownLoad',
    component: () => import('../views/recorder/downLoad'),
    meta: {
      titile: '记录仪安装包'
    }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
